import { useSelector } from 'react-redux';
import { getAuth } from 'src/redux/slices/auth';

/**
 * Custom hook to access authentication state from Redux
 * Replaces the repetitive pattern: const auth = useSelector(getAuth); const { currentAccount, currentUser, ... } = auth;
 * 
 * @returns Auth state with all user and account information
 */
export const useAuth = () => {
  return useSelector(getAuth);
};
